import { render, staticRenderFns } from "./GotopButton.vue?vue&type=template&id=16a7d612&scoped=true"
import script from "./GotopButton.vue?vue&type=script&lang=js"
export * from "./GotopButton.vue?vue&type=script&lang=js"
import style0 from "./GotopButton.vue?vue&type=style&index=0&id=16a7d612&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a7d612",
  null
  
)

export default component.exports